import { __decorate } from "tslib";
import { NgModule } from 'angular-ts-decorators';
import { DynamicPagesSpotsDisplayOptionsService } from './services/dynamic-pages-spots-display-options.service';
var DynamicPagesModule = (function () {
    function DynamicPagesModule() {
    }
    DynamicPagesModule = __decorate([
        NgModule({
            declarations: [],
            id: 'gn.audio.support.dymanic-pages',
            imports: [],
            providers: [DynamicPagesSpotsDisplayOptionsService],
        })
    ], DynamicPagesModule);
    return DynamicPagesModule;
}());
export { DynamicPagesModule };
